import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-page-confirm',
  templateUrl: './page-confirm.component.html',
  styleUrls: ['./page-confirm.component.scss'],
})
export class PageConfirmComponent implements OnInit {
  @Input() title: string;
  @Input() content: string;
  @Input() url: string;

  constructor(
    private router: Router,
    public globalService: GlobalService,
  ) {}

  ngOnInit() {}

  redirect(){
    this.router.navigate([this.url?this.url:'/perfil/dashboard']);
  }
}
